<div [hidden]="!active" class="tab-panel--item">
  <div class="wrapper" id="scroll-viewport">
    <ng-content></ng-content>
  </div>
</div>
